export default {"src":"/_next/static/media/wallet-trustwallet.8a471301.svg","height":1024,"width":1024,"blurWidth":0,"blurHeight":0};